export default __webpack_public_path__ + "media/zurb/img/events/wired/wired-img2-19139ac82d46cccdd715f949f8accc6f.png";